export const STORE_INSTRUCT_WORKFLOW = 'instructWorkflowUI';
export type STORE_INSTRUCT_WORKFLOW = typeof STORE_INSTRUCT_WORKFLOW;
export const STORE_INSTRUCT_WORKFLOW_IMPORT_EXPORT = 'instructWorkflowImportExportUI';
export type STORE_INSTRUCT_WORKFLOW_IMPORT_EXPORT = typeof STORE_INSTRUCT_WORKFLOW_IMPORT_EXPORT;
